var constants = {};

constants.api = {
    'registration.vulog.center': 'https://java-eu01.vulog.com/registration',
    'registration-us.vulog.center': 'https://java-us01.vulog.com/registration',
    'registration-test.vulog.center': 'https://java-sta.vulog.com/registration',
    'registration-qa.vulog.center': 'https://java-qa.vulog.com/registration',
    'registration-poc.vulog.center': 'https://demo-java-api.vulog.com/registration',
    'registration-dev.vulog.center': 'https://frnce-devjava-api.vulog.com/registration',
    localhost: 'http://localhost:3334/registration', //dev
    '192.168.0.107': 'http://192.168.0.107:3334/registration', //dev
    '192.168.0.103': 'http://192.168.0.103:3334/registration', //dev
    'vulogform.okapiworks.com': 'https://vulogform.okapiworks.com/api/registration', //dev-test
    // url: 'https://registration-api.ngrok.io/registration', // dev
    // url: "https://vulogform.okapiworks.com/api/registration",
    // url: "https://java-eu01.vulog.com/registration",
    // url: 'https://frnce-devjava-api.vulog.com',
    // url: "https://java-qa.vulog.com/registration", // qa
    url: 'https://java-sta.vulog.com/registration', // staging
    // url: "https://java-eu01.vulog.com/registration", // prod
    // url: "https://demo-java-api.vulog.com/registration", // poc
};

constants.cdn = {
    hostname: 'localhost',
};

export default constants;
